module.exports = __webpack_public_path__ + "officialStatic/img/index-partner-bg.89a9f39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index-partner-bg.png
// module id = MFgy
// module chunks = 0